import { Apikey, IApikey } from "@/entities";
import getEndpoint from "@/utils/domain";
import { signedRequest } from "@/utils/signedRequest";
import { Auth } from "@aws-amplify/auth";
import { ISearchRepository } from ".";
import axios from "axios";

// export const SEARCH_ENDPOINT = getEndpoint("/api/search", true);
export const SEARCH_ENDPOINT = "https://1muya3orw8.execute-api.ap-southeast-1.amazonaws.com/Prod"

export class SearchAPIRepository implements ISearchRepository {
    async autoComplete(keyword: string): Promise<string[]> {
        const response = await axios.get(`${SEARCH_ENDPOINT}/autocomplete?query=${keyword}`);
        console.log(response);
        return response.data;
    }

    async search(keyword: string): Promise<any[]> {
        return this.semanticSearch(keyword);
        // const response = await axios.get(`${SEARCH_ENDPOINT}/search?query=${keyword}&limit=30&suggester=hema_name`);
        // console.log(response);
        // return response.data;
    }

    async semanticSearch(keyword: string): Promise<any[]> {
        const response = await axios.get("https://ukn6lttj96.execute-api.ap-southeast-1.amazonaws.com/villa/api/search2/semantic_search", {
            params: {
                query: keyword,
            },
        });

        return response.data;
    }
}
